import { defineMessages } from 'react-intl';

const messages = defineMessages({
  hoverLogo: { id: 'modules-default-landingReferral-hoverLogo' },
  registerText: { id: 'modules-default-landingReferral-registerText' },
});

export default messages;
